import styles from "../../styles/portfolioManagerDashboard.module.scss"
import KpiInfoIcon from "./KpiInfoIcon"

function CardWrapper({children, classNames="", infoText}) {
  return (
    <div
      className={`${styles.cardWrapper} ${classNames}`}
    >
     <KpiInfoIcon content={infoText} />
     {children}
    </div>
  );
}

export default CardWrapper
